"use strict";

var _reactDom = require("react-dom");
var _app = _interopRequireDefault(require("components/app"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//const store = configureStore();
var root;
var init = function init() {
  (0, _reactDom.render)(/*#__PURE__*/React.createElement(_app["default"], null), document.getElementById('container'), root);
};
init();